import Swiper from "swiper";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

jQuery(($) => {
	if ($(".swiper-gallery").length > 0) {
		const swiperGallery = new Swiper(".swiper-gallery", {
			loop: false,
			spaceBetween: 45,
			slidesPerView: "auto",
			slideToClickedSlide: true,
			navigation: {
				nextEl: ".swiper-button-next-gallery",
				prevEl: ".swiper-button-prev-gallery",
			},
			breakpoints: {
				768: {
					spaceBetween: 45,
				},
				0: {
					spaceBetween: 15,
				},
			},
			modules: [Navigation],
		});
	}
});
